import axios from "axios";
import Config from "config";
import urljoin from "helpers/urljoin";
import hasAuthToken from "helpers/hasAuthToken";

const getReferralCode = async (userId: string, sourceDetails = {}) => {
  if (!hasAuthToken()) {
    return null;
  }

  const url = urljoin(Config.API_URL, `api/v1/auth/users/${userId}/referral_link`);
  try {
    const response = await axios.get(url, { params: { sourceDetails }, withCredentials: true });
    return response.data;
  } catch (error) {
    console.error("Error fetching referral code:", error);
    throw error;
  }
};

export default getReferralCode;
